//
//
//
//
//
//
export default {
  props: ["spec"],
  computed: {
    compiledText: function compiledText() {
      return Utils.format.markdown(this.spec.message);
    },
    isMarkdown: function isMarkdown() {
      return this.spec.message_format == 'markdown';
    }
  }
};